<app-modal-header [title]="'Share resource to your Google Classroom class'"></app-modal-header>
<div class="modal-body pb-4 pt-0 mt-4">
    <div class="description mb-2 modal-body-text" *ngIf="!resource.opensAsVideo">
        This link opens the resource page optimized for student viewing.
    </div>
    <div class="important-desc mb-2 modal-body-text">
        <app-icon [type]="'file-dots'" class="me-3"></app-icon> Student work results NOT available
    </div>

    <div class="important-desc mb-5 modal-body-text">
        <app-icon [type]="'lock-close'" class="me-3"></app-icon> Requires student sign in to google
    </div>
    <ng-container *ngIf="resource.opensAsVideo">
        <h5 class="mb-4 resource-label">Choose version of resource to share</h5>
        <p class="mb-2 fw-bold">Focus View (distraction-free media view)</p>
        <app-button
            (click)="openGoogleClassroom(true)"
            class="selenium-share-to-google-classroom d-block mb-6"
            [buttonClasses]="'modal-button-padding'"
            >Share to Google Classroom</app-button
        >
        <p class="mb-2 fw-bold">Full Resource View</p>
    </ng-container>

    <app-button
        (click)="openGoogleClassroom(false)"
        class="selenium-share-to-google-classroom d-block mb-6"
        [buttonClasses]="'modal-button-padding'"
        [ngClass]="{ 'text-center': !resource.opensAsVideo }"
        >Share to Google Classroom</app-button
    >
    <div class="description modal-body-text">
        Want to build a lesson with this resource first? Go to our
        <app-link (click)="openLessonBuilder()" [appRouterLink]="['/tools', 'lessonbuilder', 'new']"
            >Lesson Builder</app-link
        >
        to add instructions, questions, and additional media slides.
    </div>
</div>
